import { render, staticRenderFns } from "./ManualUpdate.vue?vue&type=template&id=4fa0fc3a&scoped=true"
import script from "./ManualUpdate.vue?vue&type=script&lang=js"
export * from "./ManualUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa0fc3a",
  null
  
)

export default component.exports